module.exports = __webpack_public_path__ + "img/meter-fire.b7ca8733.svg";